import { useAppDispatch, useAppSelector } from "../store/hooks";
import { useEffect, useState } from "react";
import { getColorFromCode, updateData } from "../api/magic_forms_2_api";
import useQuery from "../../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import FormField from "../dtos/FormField";
import { ButtonStyle } from "../../utils/Buttons/Buttons";
import { infoMessage } from "../../api/errorHandler";
import { ConstructionOutlined } from "@mui/icons-material";
import { TextFieldStyleDummies } from "../../utils/TextFieldStyle/TextFieldStyle";
import {
  addFilledId,
  commitCoreId,
  create,
  getColorsByFlowId,
  getColorsByProcessId,
  getCoreIdLink,
  getElecSigOnlyRedir,
  getElecSigUrl,
  getFlowConfigByProcessId,
  getMagicLink,
  sendFinalEmail,
} from "../api/FlowApi";

const NewDummiesSigOnly = () => {
  //query params
  const query = useQuery();
  const flowId = query.get("flowId") ?? "error";
  //State selectors

  //local states
  const [bgColor, setBgColor] = useState(["#ffffff", "#ffffff"]);
  const [dataLoaded, setDataLoaded] = useState(false);

  //get colors
  async function getColors() {
    let resp = await getColorsByFlowId(flowId);
    setBgColor([resp.backgroundColor1, resp.backgroundColor2]);
    setDataLoaded(true);
  }

  //Get ElecSig Link
  async function getElecSigRedir() {
    try{
    let resp = await getElecSigOnlyRedir(flowId);
    window.location.href = resp.url;
    } catch(e: any) {
      infoMessage("Verifica tu acceso!")
    }
  }

  useEffect(() => {
    getColors();
  }, []);
  //render loading
  if (!dataLoaded) {
    return (
      <div
        style={{
          background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
          position: "fixed",
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div style={{ marginTop: "20vh" }}>
          <ClipLoader loading={true} size={150} color={"#FFFFFF"} />
          <h1
            className="txt-label-title"
            style={{ fontSize: "", marginBottom: "50px" }}
          >
            Espera un momento
          </h1>
        </div>
      </div>
    );
  }
  //Render
  return (
    <div
      style={{
        background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
        position: "fixed",
        height: "100%",
        width: "100%",
        overflow: "auto",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          transform: "translate(-50%, -50%)",
          left: "50%",
        }}
      >
        <h1
          className="txt-label-title"
          style={{ fontSize: "", marginBottom: "50px" }}
        >
          ¡Hola!
        </h1>
        <h1
          className="txt-label"
          style={{ fontSize: "", marginBottom: "50px" }}
        >
          Vamos a firmar tu documento
        </h1>

        <div
          style={{
            marginTop: "40px",
          }}
        ></div>
        <ButtonStyle
          onClick={() => {
            getElecSigRedir();
          }}
          text="Continuar"
          width="177px"
          height="5vh"
        />
      </div>
    </div>
  );
};

export default NewDummiesSigOnly;
